import React from 'react';
import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { CatalogueEntry } from "../CatologueEntry"
import DataCache from "../../StaticData/StaticDataCache";
import { IGeneralApiClient } from "../../../Common/ApiClients/GeneralApiClient";
import { Catalogue } from "@singularsystems/neo-react-services";
import * as Roles from "../../../AccessControl/Models/Commands/Security/Roles"
import StaticTaxTypeLookup from '../../../Common/Models/StaticTaxTypeLookup';
import StaticClientEntityTypeLookup from '../../../Common/Models/StaticClientEntityTypeLookup';

export default class ClientEntityTypeEntry extends CatalogueEntry<StaticClientEntityTypeLookup> {

    constructor() {
        super("Tax Type", StaticClientEntityTypeLookup);
    }

    public get editRole() {
        return Roles.CatalogueRoles.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.clientEntityType;
    }
    
    public getSaveEndpoint(apiClient: IGeneralApiClient) {
        return apiClient.saveClientEntityTypes;
    }
    
    public renderRow(item: StaticClientEntityTypeLookup, meta: Model.TransformMetaType<StaticClientEntityTypeLookup>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.clientEntityTypeName} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}